<script setup lang="ts">
import type { NavItem } from '@/shared/contracts';
import NavIcon from './NavIcon.vue';
defineProps<{ items: NavItem[]; label: string }>();
defineEmits<{ select: [] }>();
</script>
<template><nav :aria-label="label" class="nav-list"><RouterLink v-for="item in items" :key="item.to" :to="item.to" class="nav-link press" @click="$emit('select')"><NavIcon :name="item.icon" /><span>{{ item.label }}</span></RouterLink></nav></template>
